import errorHandlers from '@/services/error-handlers';

// TODO: write tests
async function setOrderFulfillmentTime({ dispatch, rootGetters }, timestamp) {
  const { fulfillmentType } = rootGetters['session/orderDetails'];

  const isDelivery = fulfillmentType === 'delivery';

  try {
    const dispatchPayload = { fulfillmentTime: timestamp };

    if (isDelivery && timestamp) {
      const estimateResult = await dispatch('getDeliveryEstimate', timestamp);

      Object.assign(dispatchPayload, { deliveryEstimate: estimateResult });
    }

    await dispatch('orders/updateOrder', dispatchPayload, { root: true });
  }
  catch (error) {
    errorHandlers.silent(error);

    if (isDelivery) {
      const modalPayload = {
        name: 'deliveryNotAvailable',
        closeModal: 'deliveryNotAvailable',
        data: {
          timestamp,
          canTryChangingTime: true
        }
      };

      dispatch('modals/openModal', modalPayload, { root: true });

      dispatch('orders/updateOrder', { fulfillmentTime: null }, { root: true });
    }
  }
}

export { setOrderFulfillmentTime };
